import React, { FC, useState } from "react";
import { IconWithTooltip } from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import useInbox from "hooks/useInbox.ts";
import { isBrightColor, isLabelNameSliced, sliceLabelName } from "../helpers";
import { useToasts } from "react-toast-notifications";
import Image from "components/Elements/Image/Image";
import Tooltip from "components/Elements/Tooltip/Tooltip";

interface LabelTagI {
  id: string;
  encryptedMailId: string;
}

const DARK_FONT_COLOR = "#3F4648";
const LIGHT_FONT_COLOR = "#FFFFFF";

const LabelTag: FC<LabelTagI> = (props) => {
  const [loading, setLoading] = useState(false);
  const { id, encryptedMailId } = props;
  const { unlabelMails, getLabels } = useInbox();
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();
  const label = getLabels()?.[id];
  const inverseColor = isBrightColor(label?.color)
    ? DARK_FONT_COLOR
    : LIGHT_FONT_COLOR;

  const handleUnlabel = async () => {
    setLoading(true);
    try {
      await unlabelMails(
        [encryptedMailId],
        [+id],
      );
    } catch (err: any) {
      console.log(err);
      addToast(err?.message, {
        appearance: "error",
      });
      return;
    } finally {
      setLoading(false);
    }
    addToast(getTextByKey("label-removed-from-mail"), {
      appearance: "success",
    });
  };

  return (
    <div
      style={{
        backgroundColor: label?.color,
        color: inverseColor,
      }}
      className={
        "mail-label-wrapper label-feature" + (loading ? " label-disabled" : "")
      }
    >
      <span
        className="label-dot"
        style={{ backgroundColor: inverseColor }}
      ></span>
      {isLabelNameSliced(label?.name) ? (
        //@ts-ignore
        <Tooltip tooltipText={label?.name}>
          {sliceLabelName(label?.name)}
        </Tooltip>
      ) : (
        <span style={{ color: inverseColor }}>
          {sliceLabelName(label?.name)}
        </span>
      )}
      <div className="remove-icon-wrapper" onClick={handleUnlabel}>
        {loading ? (
          <Image name="preloader" ext="gif" className="label-loader" />
        ) : (
          <IconWithTooltip
            iconProps={{
              name: "x",
              small: true,
              darkGray: isBrightColor(label?.color),
              white: !isBrightColor(label?.color),
            }}
            tooltipProps={{
              tooltipText: getTextByKey("unlable-mail"),
            }}
          />
        )}
      </div>
    </div>
  );
};

export default LabelTag;
